"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var Icon_1 = require("../../../icons/Icon");

var checkSvg = require("../../../icons/checkThick-16.svg");

var minusSvg = require("../../../icons/minus-16.svg");

var styles_1 = require("./styles");

var Checkbox_1 = require("../../forms/Checkbox");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var FullTableHeaderRowCheckbox =
/** @class */
function (_super) {
  __extends(FullTableHeaderRowCheckbox, _super);

  function FullTableHeaderRowCheckbox() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FullTableHeaderRowCheckbox.prototype.render = function () {
    var _a = this.props,
        checkboxStatus = _a.checkboxStatus,
        selectHeaderRow = _a.selectHeaderRow;
    return React.createElement("div", __assign({
      role: "cell",
      className: "selectRowCell"
    }, styles_1.selectRowCellStyle), React.createElement("div", {
      onClick: function onClick() {
        return selectHeaderRow();
      },
      className: "selectHeaderRow " + (checkboxStatus === 'NONE' ? Checkbox_1.uncheckedCheckboxStyle : Checkbox_1.checkedCheckboxStyle)
    }, checkboxStatus === 'NONE' ? null : React.createElement(Icon_1.Icon, {
      src: "" + (checkboxStatus === 'ALL' ? checkSvg : minusSvg),
      width: 16,
      height: 16,
      fill: colors_1.white
    })));
  };

  return FullTableHeaderRowCheckbox;
}(React.Component);

exports.FullTableHeaderRowCheckbox = FullTableHeaderRowCheckbox;